// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:800px){.v-label{font-size:12px;padding-left:0}.v-card__title{font-size:14px;padding-left:0}.v-card__subtitle,.v-card__text{padding:0}.v-application ul,ol,p{padding-left:0}}", ""]);
// Exports
module.exports = exports;
